import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=f27c8fc6&scoped=true&lang=pug&"
import script from "./Admin.vue?vue&type=script&lang=js&"
export * from "./Admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27c8fc6",
  null
  
)

export default component.exports